<template>
  <v-navigation-drawer
    class="h-100-vh pt-70-px"
    :width="leftMenuShow ? 360 : 56"
    app
    dark
    floating
    v-model="leftNavigation"
  >
    <v-navigation-drawer
      class="h-100-vh pt-70-px bg-transparent w-100-pct"
      dark
      absolute
      floating
      v-model="leftMenuShow"
    >
      <v-app-bar
        class="bg-transparent rounded-br-lg pl-14 pt-10-px"
        fixed
        flat
        dark
      >
        <v-img
          src="/images/logo.png"
          class="d-inline-block"
          contain
          height="36"
        ></v-img>
      </v-app-bar>

      <v-list shaped class="menu px-0 pl-14 relative z-index-8">
        <v-list-item-group
          v-model="menuSelectedItem"
          color="white"
          mandatory
          class="mr-35-px mb-10-px"
        >
          <v-list-item
            v-for="(item, i) in menuItems"
            :key="i"
            @click.stop="linkTo(item.link)"
          >
            <v-list-item-content>
              <v-list-item-title class="fz-15-px">{{
                $t(item.key)
              }}</v-list-item-title>
            </v-list-item-content>
            <template v-if="editedAuth && modifyMode.show && i === 1">
              <v-btn
                :title="showRemoveData ? '隱藏已停用資訊' : '顯示已停用資訊'"
                @click.stop="setShowRemoveData"
                class="left-103-pct"
                absolute
                small
                icon
              >
                <v-icon
                  >{{ showRemoveData ? 'mdi-eye-off' : 'mdi-eye' }}
                </v-icon>
              </v-btn>
              <v-btn
                @click.stop="openDialog('addItem', item)"
                class="right-16-px"
                absolute
                small
                icon
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
          </v-list-item>
        </v-list-item-group>

        <v-treeview
          :items="mapActiveMenuList"
          :open.sync="initiallyOpen"
          dense
          open-on-click
          item-children="children"
          item-text="topic"
          item-key="menuId"
          class="fz-15-px font-weight-bold"
        >
          <template v-slot:prepend="{ item, open }">
            <v-icon v-if="!item.file">
              <template v-if="item.flag === 1">
                {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
              </template>
              <template v-else> mdi-folder-off </template>
            </v-icon>
            <v-icon v-else>
              {{ files[item.file] }}
            </v-icon>
          </template>
          <template v-slot:label="{ item }">
            <div class="topic-name" @click="clickMenu(item)">
              {{ item[topicKey] }}
              <span v-if="!item[topicKey]">
                {{ item.topic }}
              </span>
              <template v-if="item.flag === 0">(停用)</template>
            </div>
          </template>
          <template
            v-if="editedAuth && modifyMode.show"
            v-slot:append="{ item }"
          >
            <v-btn
              v-if="item.menuId !== 1"
              @click.stop="openDialog('editItemSwap', item)"
              dense
              icon
              plain
            >
              <v-icon class="fz-16-px">mdi-sort</v-icon>
            </v-btn>
            <v-btn @click.stop="openDialog('editItem', item)" dense icon plain>
              <v-icon class="fz-16-px">mdi-square-edit-outline</v-icon>
            </v-btn>
          </template>
        </v-treeview>
      </v-list>

      <DialogChapter
        v-if="editedAuth"
        :activeMenuList="activeMenuList"
        :editedAuth="editedAuth"
        @mapResult="mapResult"
      ></DialogChapter>
    </v-navigation-drawer>
    <v-navigation-drawer
      v-if="leftAppBar"
      class="text-center z-index-5"
      color="grey darken-3"
      dark
      mini-variant
      absolute
      v-model="leftAppBar"
    >
      <v-app-bar-nav-icon
        class="mt-3"
        @click.stop="setLeftMenuShow(!leftMenuShow)"
      ></v-app-bar-nav-icon>
      <v-divider class="mx-3 my-3"></v-divider>
      <v-btn
        class="my-4 bg-main"
        fab
        small
        dark
        @click.stop="$router.push({ path: '/member' })"
      >
        {{ loginUser.loginname.split('')[0] }}
      </v-btn>

      <v-btn
        v-if="editedAuth"
        class="my-2 rounded elevation-0 bg-transparent"
        :title="mode ? '切至預覽模式' : '切至編輯模式'"
        small
        fab
        @click.stop="mode = !mode"
      >
        {{ mode ? '預覽' : '編輯' }}
      </v-btn>

      <v-btn
        class="my-2 rounded elevation-0 bg-transparent"
        icon
        :title="$t('LOGOUT')"
        @click.stop="ChangeDialog('Logout')"
      >
        <v-icon>mdi-logout-variant</v-icon>
      </v-btn>

      <v-divider class="mx-3 my-3"></v-divider>
      <template v-for="(item, index) in langList">
        <v-btn
          v-if="item.key !== lang"
          :key="index"
          class="my-2 rounded elevation-0 bg-transparent"
          small
          fab
          @click="ChangeState({ key: 'lang', val: item.key })"
        >
          {{ item.text }}
        </v-btn>
      </template>

      <v-divider class="mx-3 my-3"></v-divider>
    </v-navigation-drawer>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

import DialogChapter from '@/components/elements/block/DialogChapter.vue'

export default {
  name: 'DocumentMenu',

  components: { DialogChapter },

  props: ['editedAuth', 'windowSizeName', 'leftMenu', 'topMenuShow'],

  data() {
    return {
      leftNavigation: true,
      leftAppBar: true,
      leftMenuShow: true,
      mode: false,
      menuSelectedItem: 1,
      initiallyOpen: [],
      activeMenuList: []
    }
  },

  computed: {
    ...mapState('common', [
      'modifyMode',
      'menuItems',
      'dialog',
      'lang',
      'langList'
    ]),
    ...mapState('auth', ['isLogin', 'loginUser']),
    ...mapState('document', ['showRemoveData', 'currMenuObj']),
    topicKey() {
      return this.lang === 'en' ? 'topicEn' : 'topic'
    },
    mapActiveMenuList() {
      let list = JSON.parse(JSON.stringify(this.activeMenuList))

      if (!this.modifyMode.show || !this.showRemoveData) {
        list = list.filter((item) => {
          return item.flag === 1
        })
      }

      const listLv1 = list.filter((item) => {
        return item.level === 1
      })

      const listLv2 = list.filter((item) => {
        return item.level === 2
      })

      let arr = {}
      for (const i in listLv1) {
        const curr = listLv1[i]
        arr[curr.menuId] = curr
        arr[curr.menuId].children = []
      }

      for (const j in listLv2) {
        const cur2 = listLv2[j]
        if (arr[cur2.parentId]) {
          arr[cur2.parentId].children.push(cur2)
        }
      }

      arr = Object.values(arr).sort(function (a, b) {
        return a.sn > b.sn ? 1 : -1
      })

      for (const i in arr) {
        const curr = arr[i]
        curr.children = curr.children.sort(function (a, b) {
          return a.sn > b.sn ? 1 : -1
        })
      }
      return arr
    }
  },

  watch: {
    leftMenu(val, oldVal) {
      if (val !== oldVal) {
        if (this.topMenuShow) {
          this.leftNavigation = val
        }
        this.leftMenuShow = val
      }
    },
    lang() {
      this.initData()
    },
    mode(val) {
      this.setEditBlock(val)
    },
    leftMenuShow(val, oldVal) {
      if (val !== oldVal) {
        this.$parent.$parent.setLeftMenuShow(val)
      }
    },
    windowSizeName: {
      immediate: true,
      handler(val) {
        this.leftAppBar = false
        this.leftNavigation = false
        this.leftMenuShow = false
        switch (val) {
          case 'md':
            this.mode = false
            this.leftMenuShow = false
            this.leftAppBar = false
            this.leftNavigation = false
            break
          case 'sm':
            this.mode = false
            this.leftMenuShow = false
            this.leftAppBar = false
            this.leftNavigation = false
            break
          case 'xs':
            this.mode = false
            this.leftMenuShow = false
            this.leftAppBar = false
            this.leftNavigation = false
            break
          default:
            this.leftMenuShow = true
            this.leftAppBar = true
            this.leftNavigation = true
        }
      }
    }
  },

  created() {
    this.initData()
  },

  // mounted() {},

  methods: {
    ...mapMutations('common', [
      'ChangeLoginUserMode',
      'ChangeDialog',
      'ChangeState'
    ]),
    ...mapActions('auth', ['setAuth']),
    ...mapActions('message', ['setSnackbar']),
    ...mapActions('document', [
      'setCurrentContent',
      'setSelectMenu',
      'setCreateMode',
      'setDialogChapter',
      'setAllChapter',
      'setShowRemoveData'
    ]),
    setLeftMenuShow(val) {
      this.leftMenuShow = val
    },
    initData() {
      this.$api.common.node.getAll().then((res) => {
        this.setAllChapter(res)
      })
      this.$api.common.node.getMainMenu().then((res) => {
        this.activeMenuList = res.sort(function (a, b) {
          return a.sn > b.sn ? 1 : -1
        })

        const queryMenuId = this.$router.currentRoute.query.menuId
        let selectedMenu
        if (queryMenuId) {
          selectedMenu = this.activeMenuList.find((item) => {
            return item.menuId === parseInt(queryMenuId)
          })
        } else {
          selectedMenu = this.activeMenuList.find((item) => {
            return item.menuId === 1
          })
        }

        this.clickMenu(selectedMenu)
      })
      this.setDialogChapter()
    },
    openDialog(key, item) {
      this.editedAuth && this.setDialogChapter({ key: key, data: item })
    },
    mapResult() {
      this.initData()
      this.setSnackbar({ show: true, text: 'SUCCESS' })
    },
    linkTo(link) {
      if (this.$router.currentRoute.path !== link) {
        this.$router.push({ path: link })
      }
    },
    setEditBlock(val) {
      if (this.currMenuObj.menuId === 1) {
        this.ChangeLoginUserMode([val, '60%'])
      } else {
        this.ChangeLoginUserMode([val, '30%'])
      }
    },
    clickMenu(item) {
      let fullPath
      this.setSelectMenu(item)
      this.setCreateMode({ obj: {}, mode: -1 })
      this.setCurrentContent({
        node: [],
        leaf: []
      })
      if (!item) {
        this.setSnackbar({ show: true, text: 'PERMISSION_DENIED' })
        return
      }
      if (item.menuId === 1) {
        this.$api.common.brief.getLatest({}).then((res) => {
          this.setCurrentContent(res)
        })
        fullPath = this.$route.path
      } else {
        fullPath = this.$route.path + '?menuId=' + item.menuId
        const query = this.$route.query
        if (parseInt(query.menuId) === parseInt(item.menuId) && query.ref) {
          fullPath += '&ref=' + query.ref
        }
        this.$api.common.leaf.getCtxesByMenuId4All(item.menuId).then((res) => {
          this.setCurrentContent(res)
        })
      }

      if (this.mode) {
        this.setEditBlock(this.mode)
      }

      if (this.$router.currentRoute.fullPath !== fullPath) {
        this.$router.push(fullPath)
      }
      this.initiallyOpen = item.level === 1 ? [item.menuId] : [item.parentId]
    }
  }
}
</script>

<style lang="scss" scoped>
.menu {
  .v-icon {
    // text-shadow: rgba(0, 0, 0, 0.2) 0.07em 0.07em 0.15em;
  }
  .topic-name {
    letter-spacing: 0.6px;
    // text-shadow: rgba(0, 0, 0, 0.5) 0.07em 0.08em 0.08em;
  }
}
</style>
